import React from 'react'
import { BeneficiarioUtilizacaoServico } from '../../../../interfaces/entities/UtilizacaoServicos/BeneficiarioUtilizacaoServico'
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { formatNumberToReais } from '../../../../utils/MoneyFormat'

const BenefData: React.FC<{ beneficiario: BeneficiarioUtilizacaoServico | null }> = ({ beneficiario }) => {

  const { fontSizeStyleAccessibility } = useAccessibility();

  return (
    <div className="registration-data-card-holder">
      <div className="registration-data-card-service">
        <div className="registration-data-row">
          <span style={fontSizeStyleAccessibility} className="registration-data-title">Dados de beneficiário(a)</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Nome</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{beneficiario?.nome}</span>
        </div>
        <div className="registration-data-row">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Código do Beneficiário</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{beneficiario?.codAntigoUsr}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Cartão Nacional de Saúde</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{beneficiario?.numCNS}</span>
        </div>
        <div className="registration-data-row">
          <span style={fontSizeStyleAccessibility} className="registration-data-key">Valor total do mês</span>
          <span style={fontSizeStyleAccessibility} className="registration-data-value">{formatNumberToReais(beneficiario?.valor || 0)}</span>
        </div>
      </div>
    </div>
  )
}

export default BenefData